class PickerFollowingListPaginationFactory {
  constructor(url) {
    this.url = url
  }

  createPaginationButton(page) {
    const pageButton = document.createElement('a');
    const searchParams = new URLSearchParams();
    searchParams.set('page', page);
    pageButton.classList.add('picker-following-list-pagination__button');
    pageButton.href = `${this.url}?${searchParams.toString()}`;
    pageButton.innerText = page;
    return pageButton;
  }

  /**
   * ページネーションの要素を生成します。
   * @param {number} totalPages - 総ページ数
   * @param {number} currentPage - 現在のページ
   * @returns {HTMLElement} ページネーションの要素
   */
  createPagination(totalPages, currentPage) {
    const paginationContainer = document.createElement('div');
    paginationContainer.classList.add('picker-following-list-pagination');

    // 5ページ以下の場合はすべて表示
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        const pageButton = this.createPaginationButton(i);
        if (i === currentPage) {
          pageButton.classList.add('active');
        }
        paginationContainer.appendChild(pageButton);
      }
      return paginationContainer;
    }

    // 最初、最後のページがそれぞれの端から3ページ以内の場合
    if (currentPage < 4) {
      for (let i = 1; i <= 3; i++) {
        const pageButton = this.createPaginationButton(i);
        if (i === currentPage) {
          pageButton.classList.add('active');
        }
        paginationContainer.appendChild(pageButton);
      }
      paginationContainer.appendChild(document.createTextNode('...'));
      const lastPageButton = this.createPaginationButton(totalPages);
      paginationContainer.appendChild(lastPageButton);
    } else if (currentPage > totalPages - 3) {
      const firstPageButton = this.createPaginationButton(1);
      paginationContainer.appendChild(firstPageButton);
      paginationContainer.appendChild(document.createTextNode('...'));
      for (let i = totalPages - 2; i <= totalPages; i++) {
        const pageButton = this.createPaginationButton(i);
        if (i === currentPage) {
          pageButton.classList.add('active');
        }
        paginationContainer.appendChild(pageButton);
      }
    } else {
      const firstPageButton = this.createPaginationButton(1);
      paginationContainer.appendChild(firstPageButton);
      paginationContainer.appendChild(document.createTextNode('...'));
      for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        const pageButton = this.createPaginationButton(i);
        if (i === currentPage) {
          pageButton.classList.add('active');
        }
        paginationContainer.appendChild(pageButton);
      }
      paginationContainer.appendChild(document.createTextNode('...'));
      const lastPageButton = this.createPaginationButton(totalPages);
      paginationContainer.appendChild(lastPageButton);
    }

    return paginationContainer;
  }
}
